import { sectionTitleSlide } from '../shared/section-title-slide';

export const appendixTitleSlide = () => sectionTitleSlide('Appendix');
